/**
 * Parses a "YYYY-MM-DD" string into a Date at local midnight.
 * A plain `new Date("YYYY-MM-DD")` parses as UTC midnight, which shifts the
 * calendar day in negative-offset timezones — this keeps the intended day.
 * Returns null for empty or malformed input.
 *
 * @example
 * // User is in UTC-5
 * parseLocalDate('2026-06-01') // → 2026-06-01T00:00:00.000 (local), not the prev day
 */
export const parseLocalDate = (value: string | null): Date | null => {
  if (!value) {
    return null;
  }
  const [year, month, day] = value.split('-').map(Number);
  if (!year || !month || !day) {
    return null;
  }
  return new Date(year, month - 1, day);
};
